<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" role="dialog" aria-modal="true" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                    <!-- ========== HEADER ========== -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-team-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                                <p class="cf-modal-head__sub">Gestion des tiers — clients, fournisseurs, collaborateurs &amp; serveurs</p>
                            </div>
                        </div>
                        <div class="frs-head-actions">
                            <!-- Menu Options -->
                            <div class="ti-btn-group" style="position:relative;display:inline-block;">
                                <button @click.stop="toggleMenu('options')" class="ds-btn-ghost" type="button"
                                        :aria-expanded="openMenu === 'options'">
                                    <i class="ri-settings-3-line"></i><span>Options</span>
                                    <i :class="['ri-arrow-down-s-line col-arrow', openMenu === 'options' ? 'col-arrow--open' : '']"></i>
                                </button>
                                <ul v-show="openMenu === 'options'" class="ag-menu ag-menu--wide">
                                    <li>
                                        <button @click="btncustomlib();openMenu=null" class="ag-menu-item">
                                            <i class="ri-edit-2-line cf-menu-icon"></i> Personnaliser les libellés
                                        </button>
                                    </li>
                                    <li>
                                        <button @click="exportData();openMenu=null" class="ag-menu-item">
                                            <i class="ri-file-download-line cf-menu-icon"></i> Exporter les données
                                        </button>
                                    </li>
                                    <li>
                                        <button @click="refreshData();openMenu=null" class="ag-menu-item">
                                            <i class="ri-refresh-line cf-menu-icon"></i> Actualiser
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                        </div>
                    </div>

                    <!-- ========== TOOLBAR ========== -->
                    <div class="cf-dialog-toolbar">
                        <div class="cf-toolbar-row">
                            <div class="search-wrap">
                                <i class="ri-search-line search-icon"></i>
                                <input v-model="searchQuery" type="search" class="search-input"
                                       placeholder="Rechercher par raison sociale, représentant, IFU..."
                                       @input="handleSearch">
                                <button v-if="searchQuery" @click="clearSearch" class="search-clear" aria-label="Effacer"><i class="ri-close-line"></i></button>
                            </div>
                            <button @click="btnajouter" class="ti-btn ti-btn-primary-full">
                                <i class="ri-add-line align-middle"></i><span class="hidden sm:inline">&nbsp;Nouveau {{ entityLabel }}</span><span class="sm:hidden">&nbsp;Ajouter</span>
                            </button>
                        </div>
                        <div class="cf-toolbar-meta">
                            <span class="cf-count">
                                <b>{{ filteredData.length }}</b> {{ entityLabel.toLowerCase() }}{{ filteredData.length > 1 ? 's' : '' }} trouvé{{ filteredData.length > 1 ? 's' : '' }}
                                <span v-if="isLoading" class="frs-loading"><i class="ri-loader-4-line"></i> Chargement...</span>
                            </span>
                            <div class="cf-perpage">
                                <label>Afficher</label>
                                <div class="cf-select-wrap">
                                    <select v-model="perPage" class="cf-select--sm">
                                        <option v-for="option in perPageOptions" :key="option" :value="option">{{ option }}</option>
                                    </select>
                                    <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                </div>
                                <span>entrées</span>
                            </div>
                        </div>
                    </div>

                    <!-- ========== BODY ========== -->
                    <div class="cf-dialog-body cf-dialog-body--flush">
                        <div class="table-scroll-wrap frs-scroll">

                            <!-- ===== DESKTOP : table ===== -->
                            <table class="frs-table hidden lg:table">
                                <thead>
                                    <tr>
                                        <th class="th th--center" style="width:4rem">N°</th>
                                        <th class="th">IFU</th>
                                        <th class="th">Raison sociale</th>
                                        <th class="th">Représentant</th>
                                        <th class="th">Téléphone</th>
                                        <th class="th">Adresse</th>
                                        <th class="th th--center" style="width:6rem">Actif</th>
                                        <th class="th th--center" style="width:5rem">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="paginatedData.length">
                                        <tr v-for="(item, index) in paginatedData" :key="item.pid"
                                            :class="['table-row', Number(item.actif) === 1 ? 'frs-row--off' : '']">
                                            <td class="td td--center">
                                                <span class="row-number">{{ (currentPage - 1) * perPage + index + 1 }}</span>
                                            </td>
                                            <td class="td">
                                                <span v-if="item.ifu" class="code-badge">{{ item.ifu }}</span>
                                                <span v-else class="text-muted">—</span>
                                            </td>
                                            <td class="td" style="white-space:normal;">
                                                <div style="display:flex;align-items:center;gap:10px;">
                                                    <div class="avatar--sm">{{ getInitials(item.raisonsociale) }}</div>
                                                    <div style="min-width:0;">
                                                        <p class="frs-name truncate" :title="item.raisonsociale">{{ item.raisonsociale }}</p>
                                                        <p v-if="item.codecltfrs" class="frs-code">{{ item.codecltfrs }}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="td">{{ item.representant || '—' }}</td>
                                            <td class="td">
                                                <span style="display:inline-flex;align-items:center;gap:5px;">
                                                    <i class="ri-phone-line" style="color:var(--cf-faint);"></i>{{ item.telephone || '—' }}
                                                </span>
                                            </td>
                                            <td class="td">
                                                <span class="frs-adresse truncate" :title="item.adresse">{{ item.adresse || '—' }}</span>
                                            </td>
                                            <td class="td td--center">
                                                <span :class="['badge', Number(item.actif) === 1 ? 'badge--red' : 'badge--green']">
                                                    <i :class="Number(item.actif) === 1 ? 'ri-close-line' : 'ri-check-line'"></i>
                                                    {{ Number(item.actif) === 1 ? 'Inactif' : 'Actif' }}
                                                </span>
                                            </td>
                                            <td class="td td--center actions-td" style="overflow:visible;" @click.stop>
                                                <div class="ti-btn-group" style="position:relative;display:inline-block;">
                                                    <button class="ds-btn-ghost !py-1 !px-2 !text-[0.75rem]" type="button"
                                                            :aria-expanded="openMenu === 'row_' + index"
                                                            @click.stop="toggleMenu('row_' + index)">
                                                        <i class="ri-more-2-fill"></i>
                                                    </button>
                                                    <ul v-show="openMenu === 'row_' + index" class="ag-menu">
                                                        <li>
                                                            <button @click="btnmodifier(item);openMenu=null" class="ag-menu-item">
                                                                <i class="ri-pen-nib-line cf-menu-icon"></i> Modifier
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button @click="toggleActif(item);openMenu=null" class="ag-menu-item">
                                                                <i :class="[Number(item.actif) === 1 ? 'ri-checkbox-circle-line' : 'ri-indeterminate-circle-line', 'cf-menu-icon']"></i>
                                                                {{ Number(item.actif) === 1 ? 'Activer' : 'Désactiver' }}
                                                            </button>
                                                        </li>
                                                        <li v-if="typedoc === 'col' && viewserveur === 'Serveur'">
                                                            <button @click="assignToTable(item);openMenu=null" class="ag-menu-item">
                                                                <i class="ri-layout-grid-line cf-menu-icon"></i> Assigner à une table
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button @click="btnsuppression(item);openMenu=null" class="ag-menu-item ag-menu-item--danger">
                                                                <i class="ri-delete-bin-line cf-menu-icon"></i> Supprimer
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr v-else>
                                        <td colspan="8" class="td">
                                            <div class="empty-state">
                                                <div class="empty-state__icon"><i class="ri-team-line"></i></div>
                                                <p class="empty-state__title">Aucun {{ entityLabel.toLowerCase() }} trouvé</p>
                                                <p class="empty-state__sub">{{ searchQuery ? 'Essayez de modifier vos critères de recherche' : 'Commencez par créer un nouveau ' + entityLabel.toLowerCase() }}</p>
                                                <button @click="btnajouter" class="ti-btn ti-btn-primary-full" style="margin-top:14px;">
                                                    <i class="ri-add-line align-middle"></i> Créer un {{ entityLabel.toLowerCase() }}
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <!-- ===== MOBILE : cartes ===== -->
                            <div class="lg:hidden">
                                <template v-if="paginatedData.length">
                                    <div v-for="item in paginatedData" :key="item.pid" class="mobile-card">
                                        <div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px;">
                                            <div style="display:flex;align-items:center;gap:10px;min-width:0;flex:1;">
                                                <div class="avatar--sm">{{ getInitials(item.raisonsociale) }}</div>
                                                <div style="min-width:0;flex:1;">
                                                    <div class="frs-name truncate">{{ item.raisonsociale }}</div>
                                                    <p v-if="item.codecltfrs" class="frs-code">{{ item.codecltfrs }}</p>
                                                </div>
                                            </div>
                                            <span :class="['badge', Number(item.actif) === 1 ? 'badge--red' : 'badge--green']" style="flex-shrink:0;">
                                                <i :class="Number(item.actif) === 1 ? 'ri-close-line' : 'ri-check-line'"></i>
                                                {{ Number(item.actif) === 1 ? 'Inactif' : 'Actif' }}
                                            </span>
                                        </div>
                                        <div class="mobile-extra-chips">
                                            <span class="code-badge">{{ item.ifu || '—' }}</span>
                                            <span v-if="item.representant" class="frs-chip"><i class="ri-user-line"></i> {{ item.representant }}</span>
                                            <span v-if="item.telephone" class="frs-chip"><i class="ri-phone-line"></i> {{ item.telephone }}</span>
                                        </div>
                                        <p v-if="item.adresse" class="frs-adresse" style="margin-top:8px;max-width:none;">{{ item.adresse }}</p>
                                        <div class="mobile-card__actions">
                                            <button @click="openMobileActions(item)" class="ds-btn-ghost !py-1 !px-2 !text-[0.75rem]" type="button">
                                                <i class="ri-more-2-fill"></i> Actions
                                            </button>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="empty-state">
                                        <div class="empty-state__icon"><i class="ri-team-line"></i></div>
                                        <p class="empty-state__title">Aucun {{ entityLabel.toLowerCase() }} trouvé</p>
                                        <p class="empty-state__sub">{{ searchQuery ? 'Essayez de modifier vos critères de recherche' : 'Commencez par créer un nouveau ' + entityLabel.toLowerCase() }}</p>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <!-- ========== FOOTER / PAGINATION ========== -->
                    <div class="cf-dialog-foot cf-dialog-foot--split">
                        <p class="cf-foot-info">
                            Affichage de <b>{{ paginationStart }}</b> à <b>{{ paginationEnd }}</b> sur <b>{{ filteredData.length }}</b> résultats
                        </p>
                        <div class="cf-foot-actions">
                            <span class="sm:hidden cf-foot-info">{{ currentPage }} / {{ totalPages }}</span>
                            <div class="pagination" v-if="totalPages > 1">
                                <button class="page-btn page-btn--nav" @click="currentPage--" :disabled="currentPage === 1"><i class="ri-arrow-left-s-line"></i></button>
                                <template v-for="pageNum in displayedPages" :key="pageNum">
                                    <span v-if="pageNum === '...'" class="cf-ellipsis">…</span>
                                    <button v-else class="page-btn" :class="{ 'page-btn--active': currentPage === pageNum }" @click="currentPage = pageNum">{{ pageNum }}</button>
                                </template>
                                <button class="page-btn page-btn--nav" @click="currentPage++" :disabled="currentPage === totalPages || totalPages === 0"><i class="ri-arrow-right-s-line"></i></button>
                            </div>
                            <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                        </div>
                    </div>

                </div>
            </Transition>

            <!-- Mobile Action Sheet -->
            <Transition name="slide-up">
                <div v-if="showMobileActionSheet && selectedItem" class="frs-sheet">
                    <div class="frs-sheet__backdrop" @click="closeMobileActions"></div>
                    <div class="frs-sheet__panel">
                        <div class="frs-sheet__handle"></div>
                        <div class="frs-sheet__head">
                            <p class="frs-sheet__label">{{ entityLabel }}</p>
                            <p class="frs-sheet__title">{{ selectedItem.raisonsociale }}</p>
                        </div>
                        <div class="frs-sheet__list">
                            <button @click="btnmodifier(selectedItem); closeMobileActions()" class="frs-sheet__item">
                                <i class="ri-pen-nib-line cf-menu-icon"></i><span>Modifier</span>
                            </button>
                            <button @click="toggleActif(selectedItem); closeMobileActions()" class="frs-sheet__item">
                                <i :class="[Number(selectedItem.actif) === 1 ? 'ri-checkbox-circle-line' : 'ri-indeterminate-circle-line', 'cf-menu-icon']"></i>
                                <span>{{ Number(selectedItem.actif) === 1 ? 'Activer' : 'Désactiver' }}</span>
                            </button>
                            <button v-if="typedoc === 'col' && viewserveur === 'Serveur'"
                                    @click="assignToTable(selectedItem); closeMobileActions()" class="frs-sheet__item">
                                <i class="ri-layout-grid-line cf-menu-icon"></i><span>Assigner à une table</span>
                            </button>
                            <button @click="btnsuppression(selectedItem); closeMobileActions()" class="frs-sheet__item frs-sheet__item--danger">
                                <i class="ri-delete-bin-line"></i><span>Supprimer</span>
                            </button>
                        </div>
                        <div class="frs-sheet__foot">
                            <button @click="closeMobileActions" class="frs-sheet__cancel">Annuler</button>
                        </div>
                    </div>
                </div>
            </Transition>

            <!-- Modal de confirmation Activer / Désactiver -->
            <Transition name="modal-fade">
                <div v-if="showConfirmToggle && toggleTarget" class="cf-overlay cf-overlay--top" @click.self="cancelToggle">
                    <div class="cf-dialog cf-dialog--sm" @click.stop>
                        <div class="cf-modal-head cf-dialog-head">
                            <div class="cf-modal-head__main">
                                <span class="cf-modal-head__icon"><i :class="Number(toggleTarget.actif) === 1 ? 'ri-checkbox-circle-line' : 'ri-indeterminate-circle-line'"></i></span>
                                <div>
                                    <h4 class="cf-dialog-title">{{ Number(toggleTarget.actif) === 1 ? 'Activer' : 'Désactiver' }} {{ entityLabel.toLowerCase() }}</h4>
                                    <p class="cf-modal-head__sub">{{ toggleTarget.raisonsociale }}</p>
                                </div>
                            </div>
                            <button @click="cancelToggle" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                        </div>
                        <div class="cf-dialog-body">
                            <div :class="['cf-note', Number(toggleTarget.actif) === 1 ? 'cf-note--info' : 'cf-note--danger']">
                                Voulez-vous vraiment {{ Number(toggleTarget.actif) === 1 ? 'activer' : 'désactiver' }}
                                <b>{{ toggleTarget.raisonsociale }}</b> ?
                            </div>
                        </div>
                        <div class="cf-dialog-foot">
                            <button @click="cancelToggle" type="button" class="ti-btn ti-btn-secondary-full">Non</button>
                            <button @click="confirmToggle" type="button"
                                    :class="Number(toggleTarget.actif) === 1 ? 'ti-btn ti-btn-primary-full' : 'ti-btn ti-btn-danger-full'">
                                Oui, {{ Number(toggleTarget.actif) === 1 ? 'activer' : 'désactiver' }}
                            </button>
                        </div>
                    </div>
                </div>
            </Transition>

            <!-- Composants Enfants -->
            <modalform ref="modalform" @closed="load" />
            <modalformsuppression @closed="load" ref="modalformsuppression" />
            <modalcustomlib ref="modalcustomlib" @elementSelectionnecustomlib="handleElementSelectedcustomlib" />
        </div>
    </Transition>
</template>


<script>
    const axios = require('axios');
    import modalcustomlib from "@/components/views/pages/gestioncommerciale/modal_customlib";
    import modalform from "@/components/views/pages/gestioncommerciale/frscltcolb/form";
    import modalformsuppression from "@/components/views/pages/gestioncommerciale/frscltcolb/formsuppression";
    import { isset, randomString } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "ClientFournisseurManager",

        components: {
            modalform,
            modalformsuppression,
            modalcustomlib
        },

        data() {
            return {
                isdisplay: false,
                titlemodal: "",
                typedoc: "",
                viewserveur: "none",

                // Données
                datatable: [],
                otherdata: [],
                datainputlibelleforms: [],
                customlibelleforms: {},

                // État UI
                showOptionsMenu: false,
                openMenu: null,
                showMobileActionSheet: false,
                isLoading: false,
                selectedItem: null,

                // Confirmation activation/désactivation
                showConfirmToggle: false,
                toggleTarget: null,

                // Filtres et recherche
                searchQuery: "",
                searchDebounce: null,

                // Pagination
                currentPage: 1,
                perPage: 50,
                perPageOptions: [10, 25, 50, 100, 200],
            };
        },

        computed: {
            entityLabel() {
                const labels = {
                    'frs': 'Fournisseur',
                    'clt': 'Client',
                    'col': 'Collaborateur'
                };
                let label = labels[this.typedoc] || 'Enregistrement';
                if (this.typedoc === 'col' && this.viewserveur === 'Serveur') {
                    label = 'Serveur';
                }
                return label;
            },

            filteredData() {
                if (!this.searchQuery) return this.datatable;

                const query = this.searchQuery.toLowerCase();
                return this.datatable.filter(item =>
                    item.raisonsociale?.toLowerCase().includes(query) ||
                    item.representant?.toLowerCase().includes(query) ||
                    item.ifu?.toLowerCase().includes(query) ||
                    item.telephone?.toLowerCase().includes(query) ||
                    item.codecltfrs?.toLowerCase().includes(query)
                );
            },

            paginatedData() {
                const start = (this.currentPage - 1) * this.perPage;
                const end = start + this.perPage;
                return this.filteredData.slice(start, end);
            },

            totalPages() {
                return Math.ceil(this.filteredData.length / this.perPage) || 1;
            },

            displayedPages() {
                const pages = [];
                const total = this.totalPages;
                const current = this.currentPage;

                if (total <= 7) {
                    for (let i = 1; i <= total; i++) pages.push(i);
                } else {
                    if (current <= 3) {
                        pages.push(1, 2, 3, 4, '...', total);
                    } else if (current >= total - 2) {
                        pages.push(1, '...', total - 3, total - 2, total - 1, total);
                    } else {
                        pages.push(1, '...', current - 1, current, current + 1, '...', total);
                    }
                }
                return pages;
            },

            paginationStart() {
                return this.filteredData.length === 0 ? 0 : (this.currentPage - 1) * this.perPage + 1;
            },

            paginationEnd() {
                return Math.min(this.currentPage * this.perPage, this.filteredData.length);
            },
        },

        watch: {
            searchQuery() {
                this.currentPage = 1;
            },
            perPage() {
                this.currentPage = 1;
            },
        },

        methods: {
            // Gestion du Modal
            show(titlemodal, typedoc, viewserveur = 'none') {
                this.titlemodal = titlemodal;
                this.typedoc = typedoc;
                this.viewserveur = viewserveur;

                this.resetState();
                this.loadInitialData();
                this.isdisplay = true;
                document.body.style.overflow = 'hidden';
            },

            close() {
                this.isdisplay = false;
                document.body.style.overflow = '';
                this.closeAllMenus();
                this.$emit('closed');
            },

            resetState() {
                this.searchQuery = "";
                this.currentPage = 1;
                this.datatable = [];
                this.showOptionsMenu = false;
                this.showMobileActionSheet = false;
                this.selectedItem = null;
                this.showConfirmToggle = false;
                this.toggleTarget = null;
            },

            closeAllMenus() {
                this.showOptionsMenu = false;
                this.showMobileActionSheet = false;
            },

            // Menu et Actions
            toggleOptionsMenu() {
                this.showOptionsMenu = !this.showOptionsMenu;
            },

            // ── Menus (charte : un seul menu ouvert + clic extérieur) ──
            toggleMenu(key) {
                this.openMenu = this.openMenu === key ? null : key;
            },

            handleGlobalClick(e) {
                if (!e.target.closest('.ti-btn-group')
                    && !e.target.closest('.ag-menu')
                    && !e.target.closest('.ds-btn-ghost')) {
                    this.openMenu = null;
                }
            },

            openMobileActions(item) {
                this.selectedItem = item;
                this.showMobileActionSheet = true;
            },

            closeMobileActions() {
                this.showMobileActionSheet = false;
                this.selectedItem = null;
            },

            // Gestion des données
            async loadInitialData() {
                await Promise.all([
                    this.loadcustomlib(),
                    this.loadinputlibelleforms(),
                    this.loadreturnotherdata(),
                    this.load()
                ]);
            },

            async load() {
                this.isLoading = true;
                try {
                    const url = `${process.env.VUE_APP_API_URL}/egldsds74gescom8571714dfe/cltfrs/all/${this.typedoc}/${this.$store.state.appsociete}/${randomString()}`;
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        this.datatable = response.data.m || [];
                    }
                } catch (error) {
                    console.error('Error loading data:', error);
                    this.datatable = [];
                } finally {
                    this.isLoading = false;
                }
            },

            async loadreturnotherdata() {
                try {
                    const url = `${process.env.VUE_APP_API_URL}/ar85474524otherdatadofodfidfoioienf55485/ges/${this.$store.state.appsociete}/${randomString()}`;
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        this.otherdata = response.data.otherdata || [];
                    }
                } catch (error) {
                    console.error('Error loading other data:', error);
                }
            },

            async loadinputlibelleforms() {
                const storedLabels = JwtService.getVALUEDATAPRICE();
                if (isset(storedLabels)) {
                    this.datainputlibelleforms = JSON.parse(storedLabels);
                    return;
                }

                try {
                    const url = `${process.env.VUE_APP_API_URL}/12478855libelinputindex2iofdofiloadexp2/${this.$store.state.appsociete}/${randomString()}`;
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        this.datainputlibelleforms = response.data.valuedataprice;
                        JwtService.setVALUEDATAPRICE(JSON.stringify(this.datainputlibelleforms));
                    }
                } catch (error) {
                    console.error('Error loading input labels:', error);
                }
            },

            loadcustomlib() {
                const storedLabels = JwtService.getCUSTOMLIBELLEFRSCLT();
                if (isset(storedLabels)) {
                    this.customlibelleforms = JSON.parse(storedLabels);
                } else {
                    this.customlibelleforms = this.$store.state.appcustomlibellefrsclt;
                    JwtService.setCUSTOMLIBELLEFRSCLT(JSON.stringify(this.customlibelleforms));
                }
            },

            // Actions CRUD
            btnajouter() {
                const titleMap = {
                    'frs': "Enregistrer un fournisseur",
                    'clt': "Enregistrer un client",
                    'col': this.viewserveur === 'Serveur' ? "Enregistrer un serveur" : "Enregistrer un collaborateur"
                };

                const Item = {
                    pid: '',
                    codecltfrs: '',
                    codeclient: '',
                    raisonsociale: '',
                    representant: '',
                    typ: this.typedoc,
                    jsondata: {
                        comptetva: null,
                        typecollaborateur: this.viewserveur,
                        general: { adresse: '', telephone: '', ifu: '' },
                        adresses: { info: '', info1: '', info2: '', info3: '' },
                        contacts: { info: '', info1: '', info2: '', info3: '' },
                        autreinfo: {},
                        paramdindication: { param: null, param1: null },
                    },
                    jsonother: {}
                };

                this.$refs.modalform.show(
                    titleMap[this.typedoc],
                    "add",
                    this.typedoc,
                    Item,
                    this.otherdata,
                    this.datainputlibelleforms,
                    this.customlibelleforms,
                    this.viewserveur
                );
            },

            btnmodifier(item) {
                const title = `Modifier ${item.raisonsociale}`;
                this.$refs.modalform.show(
                    title,
                    "update",
                    this.typedoc,
                    item,
                    this.otherdata,
                    this.datainputlibelleforms,
                    this.customlibelleforms,
                    this.viewserveur
                );
            },

            btnsuppression(item) {
                if (item.useline === 1 || item.useline === '1') {
                    this.$toast?.error("Impossible de supprimer. Cet enregistrement est utilisé ailleurs.");
                    return;
                }

                const title = `Voulez-vous vraiment supprimer ${item.raisonsociale} ?`;
                this.$refs.modalformsuppression.show(title, item, this.typedoc);
            },

            // Utilitaires
            handleSearch() {
                if (this.searchDebounce) clearTimeout(this.searchDebounce);
                this.searchDebounce = setTimeout(() => {
                    this.currentPage = 1;
                }, 300);
            },

            clearSearch() {
                this.searchQuery = "";
            },

            refreshData() {
                this.showOptionsMenu = false;
                this.load();
            },

            exportData() {
                this.showOptionsMenu = false;
                // Implémenter l'exportation
                console.log('Export functionality to implement');
            },

            assignToTable(item) {
                this.showMobileActionSheet = false;
                // Implémenter l'assignation à une table
                console.log('Assign to table:', item);
            },

            toggleActif(item) {
                // Ouvre le modal de confirmation Oui/Non
                this.toggleTarget = item;
                this.showConfirmToggle = true;
            },

            cancelToggle() {
                this.showConfirmToggle = false;
                this.toggleTarget = null;
            },

            async confirmToggle() {
                const item = this.toggleTarget;
                if (!item) return;

                const nouvelEtat = Number(item.actif) === 1 ? 0 : 1;
                this.showConfirmToggle = false;
                this.$store.dispatch('lancerchargement', true);
                try {
                    const url = `${process.env.VUE_APP_API_URL}/egldsds74gescom8571714dfe/cltfrs/toggleactif/${this.typedoc}/${this.$store.state.appsociete}/${randomString()}`;
                    const response = await axios.post(url, { pid: item.pid, actif: nouvelEtat }, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        this.$toast?.success(response.data.message);
                        await this.load();
                    } else {
                        const msg = (response.data.datamessage && response.data.datamessage.length > 0)
                            ? response.data.datamessage.join(', ')
                            : (response.data.message || 'Une erreur est survenue');
                        this.$toast?.error(msg);
                    }
                } catch (error) {
                    console.error('Error toggling actif:', error);
                    this.$toast?.error("Une erreur est survenue. Veuillez contacter votre administrateur.");
                } finally {
                    this.$store.dispatch('lancerchargement', false);
                    this.toggleTarget = null;
                }
            },

            getInitials(name) {
                if (!name) return '?';
                return name.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
            },

            btncustomlib() {
                this.showOptionsMenu = false;
                this.$refs.modalcustomlib.show(this.customlibelleforms, 'frsclt');
            },

            handleElementSelectedcustomlib(selection) {
                this.customlibelleforms = selection.value;
            },
        },

        mounted() {
            document.addEventListener('click', this.handleGlobalClick)
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleGlobalClick)
            document.body.style.overflow = '';
        },
    };
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only). Recopié des modèles stock/fichetechnique + stock/articles. */

/* ===== MODALE ===== */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-overlay--top { z-index:1100; }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1100px; }
.cf-dialog--sm { max-width:460px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; gap:0.75rem; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.frs-head-actions { display:flex; align-items:center; gap:0.5rem; flex-shrink:0; }
.cf-dialog-toolbar { padding:0.75rem 1.25rem; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; min-height:0; }
.cf-dialog-body--flush { padding:0; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-foot--split { justify-content:space-between; flex-wrap:wrap; }
.cf-foot-actions { display:flex; align-items:center; gap:0.5rem; flex-wrap:wrap; justify-content:flex-end; }
.cf-foot-info { font-size:0.78rem; color:var(--cf-muted); margin:0; }
.cf-foot-info b { color:var(--cf-ink-strong); }

/* ===== TOOLBAR ===== */
.cf-toolbar-row { display:flex; gap:0.6rem; align-items:center; flex-wrap:wrap; }
.search-wrap { position:relative; flex:1; min-width:200px; }
.search-icon { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:var(--cf-faint); }
.search-input { width:100%; padding:9px 34px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); font-size:0.82rem; color:var(--cf-ink); outline:none; transition:border-color 0.2s; background:#fff; }
.search-input:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.search-clear { position:absolute; right:8px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:var(--cf-faint); }
.cf-toolbar-meta { display:flex; align-items:center; justify-content:space-between; margin-top:0.7rem; gap:0.75rem; flex-wrap:wrap; }
.cf-count { font-size:0.8rem; color:var(--cf-muted); }
.cf-count b { color:var(--cf-ink-strong); }
.frs-loading { display:inline-flex; align-items:center; gap:5px; margin-left:10px; color:rgb(var(--primary)); font-weight:600; }
.frs-loading i { animation:frs-spin 1s linear infinite; }
@keyframes frs-spin { to { transform:rotate(360deg); } }
.cf-perpage { display:flex; align-items:center; gap:0.4rem; font-size:0.8rem; color:var(--cf-muted); }
.cf-select-wrap { position:relative; }
.cf-select--sm { appearance:none; height:34px; padding:0 28px 0 10px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; font-size:0.8rem; color:var(--cf-ink); cursor:pointer; outline:none; }
.cf-select--sm:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-select-arrow { position:absolute; right:10px; top:50%; transform:translateY(-50%); color:var(--cf-faint); pointer-events:none; }
.col-arrow { font-size:16px; transition:transform 0.2s; }
.col-arrow--open { transform:rotate(180deg); }

/* ===== MENU 3 POINTS (charte §2) ===== */
.ag-menu { position:absolute; top:calc(100% + 4px); right:0; z-index:30; min-width:180px; margin:0; padding:0.3rem; list-style:none; background:#fff; border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); box-shadow:var(--cf-shadow-md); }
.ag-menu--wide { min-width:240px; }
.ag-menu-item { display:flex; align-items:center; width:100%; padding:0.45rem 0.6rem; border:0; background:transparent; font-size:0.8rem; color:var(--cf-ink); text-align:left; cursor:pointer; border-radius:var(--cf-radius-xs); white-space:nowrap; }
.ag-menu-item:hover { background:var(--cf-surface-alt); }
.ag-menu-item--danger { color:rgb(var(--danger)); }
.ag-menu-item--danger .cf-menu-icon { color:rgb(var(--danger)); }

/* ===== TABLE ===== */
.table-scroll-wrap { overflow:auto; }
.frs-scroll { max-height:58vh; }
.frs-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:760px; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.frs-row--off { opacity:0.6; }
.td { padding:0.65rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td--center { text-align:center; }
.row-number { color:var(--cf-faint); font-variant-numeric:tabular-nums; font-size:0.78rem; }
.text-muted { color:var(--cf-faint); }
.code-badge { font-family:monospace; font-size:0.7rem; padding:2px 8px; background:var(--cf-surface-alt); color:var(--cf-ink); border-radius:var(--cf-radius-xs); font-weight:600; }
.avatar--sm { width:34px; height:34px; min-width:34px; background:rgb(var(--primary) / 0.12); color:rgb(var(--primary)); border-radius:var(--cf-radius-sm); display:flex; align-items:center; justify-content:center; font-size:0.8rem; font-weight:700; }
.frs-name { font-weight:500; color:var(--cf-ink-strong); max-width:220px; margin:0; }
.frs-code { font-size:11px; color:var(--cf-faint); margin:0; }
.frs-adresse { display:inline-block; max-width:180px; vertical-align:middle; }
.frs-chip { display:inline-flex; align-items:center; gap:4px; font-size:0.72rem; color:var(--cf-muted); }
.badge { display:inline-flex; align-items:center; gap:4px; padding:2px 9px; border-radius:999px; font-size:0.66rem; font-weight:700; }
.badge--green { background:#dcfce7; color:#15803d; }
.badge--red { background:#fee2e2; color:#b91c1c; }

/* ===== EMPTY STATE ===== */
.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0 0 6px; }
.empty-state__sub { font-size:0.82rem; color:var(--cf-muted); margin:0; }

/* ===== MOBILE CARDS ===== */
.mobile-card { padding:0.9rem 1rem; border-bottom:1px solid var(--cf-surface-alt); }
.mobile-extra-chips { display:flex; flex-wrap:wrap; gap:8px; margin-top:10px; align-items:center; }
.mobile-card__actions { display:flex; gap:8px; margin-top:12px; padding-top:12px; border-top:1px solid var(--cf-surface-alt); }

/* ===== PAGINATION ===== */
.pagination { display:flex; align-items:center; gap:4px; }
.cf-ellipsis { padding:0 4px; color:var(--cf-faint); }
.page-btn { min-width:30px; height:30px; padding:0 8px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; color:var(--cf-ink); font-size:0.78rem; font-weight:600; cursor:pointer; transition:all 0.15s; }
.page-btn:hover:not(:disabled) { border-color:rgb(var(--primary) / 0.35); background:var(--cf-surface); }
.page-btn:disabled { opacity:0.5; cursor:not-allowed; }
.page-btn--active { background:rgb(var(--primary)); border-color:rgb(var(--primary)); color:#fff; }
.page-btn--nav { width:34px; display:inline-flex; align-items:center; justify-content:center; }

/* ===== ACTION SHEET (mobile) ===== */
.frs-sheet { position:fixed; inset:0; z-index:1050; }
.frs-sheet__backdrop { position:absolute; inset:0; background:rgb(15 23 42 / 0.45); }
.frs-sheet__panel { position:absolute; bottom:0; left:0; right:0; background:#fff; border-radius:var(--cf-radius) var(--cf-radius) 0 0; padding-bottom:env(safe-area-inset-bottom, 0); box-shadow:var(--cf-shadow-md); }
.frs-sheet__handle { width:48px; height:5px; background:var(--cf-border); border-radius:999px; margin:10px auto 0; }
.frs-sheet__head { padding:0.9rem 1.25rem; border-bottom:1px solid var(--cf-border); }
.frs-sheet__label { font-size:0.75rem; color:var(--cf-muted); margin:0; }
.frs-sheet__title { font-size:1rem; font-weight:700; color:var(--cf-ink-strong); margin:0; }
.frs-sheet__list { padding:0.4rem 0; }
.frs-sheet__item { display:flex; align-items:center; gap:12px; width:100%; padding:0.8rem 1.25rem; border:0; background:transparent; font-size:0.88rem; color:var(--cf-ink); text-align:left; cursor:pointer; }
.frs-sheet__item:hover { background:var(--cf-surface-alt); }
.frs-sheet__item i { font-size:1.1rem; }
.frs-sheet__item--danger, .frs-sheet__item--danger i { color:rgb(var(--danger)); }
.frs-sheet__foot { padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); }
.frs-sheet__cancel { width:100%; padding:0.65rem; border:0; border-radius:var(--cf-radius-sm); background:var(--cf-surface-alt); color:var(--cf-muted); font-weight:600; font-size:0.85rem; cursor:pointer; }
.frs-sheet__cancel:hover { background:var(--cf-border); }

/* ===== TRANSITIONS ===== */
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }
.slide-up-enter-active, .slide-up-leave-active { transition:all 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
.slide-up-enter-from, .slide-up-leave-to { opacity:0; transform:translateY(100%); }

/* Scrollbar fine */
.frs-scroll::-webkit-scrollbar { width:6px; height:6px; }
.frs-scroll::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }

@media (max-width:768px) { .cf-dialog--xxl { max-width:100%; } .frs-scroll { max-height:64vh; } }
</style>
